import initApm, { ApmBase } from "@elastic/apm-rum";
import { apmEnabled } from "../../shared/Config";
import { apmConfig } from "../config/apm/apm.config";
import { ApmContextService } from "../services/apm/apm-context.service";
import { setupApmAxiosInterceptors } from "../interceptors/apm-http.interceptor";

let initialized = false;
let apmInstance: ApmBase | undefined;
let apmContext: ApmContextService | undefined;

export function getApm(): ApmBase | undefined {
  return apmInstance;
}

export function getApmContext(): ApmContextService | undefined {
  return apmContext;
}

export async function initializeApm(): Promise<void> {
  if (initialized) return;
  initialized = true;

  if (!apmEnabled) return;
  if (!apmConfig.serverUrl) return;

  try {
    apmInstance = initApm(apmConfig as any);
    apmContext = new ApmContextService(apmInstance);

    // Wire HTTP instrumentation (axios) with tracing fallback behavior.
    setupApmAxiosInterceptors(apmInstance, apmContext);
  } catch {
    apmInstance = undefined;
    apmContext = undefined;
  }
}

